// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

export const StyledDivV4 = styled.div`
  .tcp_carousel_wrapper {
    max-height: 248px !important;
  }
  margin-bottom: 20px;
  padding-bottom: 24px;
  .image-link > pre {
    white-space: break-spaces;
    font-size: 12px !important;
    margin: 0 !important;
    font-weight: 700;
    padding: 0px 13px !important;
    height: 31px;
    justify-content: center;
    align-items: center;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: horizontal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
    letter-spacing: normal;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    @media (max-width: 1199px) {
      font-size: 12px !important;
      padding: 5px 3.5px !important;
    }
  }

  .container-carousel {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    display: flex;
  }
  .container-carousel::-webkit-scrollbar {
    display: none;
  }
  .carousel-inner-container {
    display: inline-block;
    width: 177px;
  }
  .slick-list {
    max-width: 100% !important;
    @media (min-width: 1200px) and (max-width: 1350px) {
      max-height: 250px;
    }
    @media (min-width: 1800px) {
      width: 1800px;
      margin: auto;
    }
  }

  @media (min-width: 1200px) {
    .slick-track {
      display: flex !important;
      align-items: center;
      justify-content: center;
    }
    .slick-slide {
      ${({ shouldHideLeftNavigation }) =>
        !shouldHideLeftNavigation && 'max-width: 142px !important;'}
    }
  }

  ${({
    isMountedHideLeftNavigationOnPLPEnabled,
    shouldHideLeftNavigation,
    configMapV4Default,
    mediaLinkedListLength,
  }) => {
    if (
      isMountedHideLeftNavigationOnPLPEnabled &&
      !shouldHideLeftNavigation &&
      !isEmpty(configMapV4Default)
    ) {
      let styles = '';
      const minWidth = 1351;
      let previousMaxWidth = minWidth - 1;

      // eslint-disable-next-line no-restricted-syntax
      for (const [maxWidth, slidesToShow] of Object.entries(configMapV4Default)) {
        const infinite = mediaLinkedListLength > slidesToShow;
        if (!infinite) {
          styles += `
            @media (min-width: ${previousMaxWidth + 1}px) and (max-width: 9999px) {
             .slick-track { width: auto !important;}
            }
          `;
          break;
        }
        previousMaxWidth = parseInt(maxWidth, 10);
      }
      return styles;
    }
    return '';
  }}

  ${({
    isMountedHideLeftNavigationOnPLPEnabled,
    mediaLinkedListLength,
    configMapV4HiddenLeftNav,
    shouldHideLeftNavigation,
  }) => {
    if (
      isMountedHideLeftNavigationOnPLPEnabled &&
      !isEmpty(configMapV4HiddenLeftNav) &&
      shouldHideLeftNavigation
    ) {
      let styles = '';
      const minWidth = 1200;
      let previousMaxWidth = minWidth - 1;

      // eslint-disable-next-line no-restricted-syntax
      for (const [maxWidth, slidesToShow] of Object.entries(configMapV4HiddenLeftNav)) {
        const infinite = mediaLinkedListLength > slidesToShow;
        if (!infinite) {
          styles += `
            @media (min-width: ${previousMaxWidth + 1}px) and (max-width: 9999px) {
              .slick-slide { max-width: 142px !important;}
            }
          `;
          break;
        }
        previousMaxWidth = parseInt(maxWidth, 10);
      }
      return styles;
    }
    return '';
  }}

  @media ${(props) => props.theme.mediaQuery.large} {
    .container-carousel-desktop {
      width: 100%;
    }
  }
  .heading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    text-align: center;
  }
  .subheading {
    padding-left: 28px;
    padding-right: 28px;
    padding-top: 24px;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: #1a1a1a;
    margin-bottom: 32px !important;
    text-transform: capitalize;
    display: flex;
    justify-content: center;
  }
  .slick-arrow {
    top: calc(50% - 20px);
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .heading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }
  .tile-container {
    @media (min-width: 1351px) {
      width: 102px !important;
    }
    @media (min-width: 1200px) and (max-width: 1350px) {
      width: 136px !important;
    }
    @media (max-width: 1199px) {
      left: 0px;
      top: 0px;
      margin-right: 5px !important;
      width: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 90px !important;
      border: none;
    }
  }
  .tile-container.active-category {
    border: none !important;
  }

  .carousel-image {
    @media (max-width: 1200px) {
      margin: 0 auto -6px;
    }
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .container-carousel .tile-container {
    @media (max-width: 1200px) {
      margin: 0 0 0 20px !important;
    }
  }

  @media (max-width: 1200px) {
    margin-bottom: 14px;
    padding-bottom: 15px;
    .subheading + div::before {
      display: none !important;
    }
    .container-carousel {
      padding-left: 0 !important;
      border: none !important;
    }
    .subheading + div {
      margin-left: 0 !important;
    }
    .subheading {
      padding-top: 15px;
      margin-bottom: 15px !important;
    }
  }
  @media (min-width: 1200px) {
    .slick-slider {
      margin-left: 1% !important;
    }
  }
  .slick-next {
    top: -41px;
    width: 18px;
    height: 21px;
    right: 14px;
    background-color: #f5f5f5;
    border-radius: 100%;
    padding: 19px;
    background-size: 6px;
  }

  .slick-prev {
    top: -41px;
    width: 18px;
    height: 21px;
    left: unset;
    right: 65px;
    background-color: #f5f5f5;
    border-radius: 100%;
    padding: 19px;
    background-size: 6px;
  }
  .slick-disabled {
    filter: opacity(50%);
  }
  .subheading + div {
    display: block !important;
  }

  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 124%;
    margin-bottom: 8px;
    border: 1px solid #dad8d8;
    border-radius: 10px;
    @media (max-width: 350px) {
      min-width: 120px;
    }
    @media (min-width: 351px) and (max-width: 409px) {
      min-width: 82px;
    }
    @media (min-width: 410px) and (max-width: 767px) {
      min-width: 95px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-width: 95px;
    }
  }
  .aspect-ratio-box:hover {
    @media ${(props) => props.theme.mediaQuery.large} {
      box-shadow: 8px 8px 16px 4px rgba(0, 0, 0, 0.12) !important;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      box-shadow: 8px 8px 16px 4px rgba(0, 0, 0, 0.12) !important;
    }
  }

  .aspect-ratio-box.active-category {
    box-shadow: 8px 8px 16px 4px rgba(0, 0, 0, 0.12) !important;
  }

  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;
export default StyledDivV4;
